import React from 'react';
import RegisterComponent from '../../component/dashboard/user/register';


function RegisterPage() {
  return (
    <>
      <RegisterComponent />
    </>
  )
}

export default RegisterPage